import { render, staticRenderFns } from "./GenericReviewerCard.vue?vue&type=template&id=587b1ac2&scoped=true"
import script from "./GenericReviewerCard.vue?vue&type=script&lang=js"
export * from "./GenericReviewerCard.vue?vue&type=script&lang=js"
import style0 from "./GenericReviewerCard.vue?vue&type=style&index=0&id=587b1ac2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587b1ac2",
  null
  
)

export default component.exports